import logos from "./components/logos";
import menu from "./components/menu";
import glightbox from "./components/glightbox";
import slider from "./components/slider";
import accordion from "./components/accordion";
import infiniteScroll from "./components/infiniteScroll";
import newsletter from "./components/newsletter";
import loading from "./components/loading";


console.log('Vite + WordPress setup running!');

function injectHeaderHeightVariable () {
    const siteHeader = document.querySelector('header.site-header');

    if (siteHeader) {
        const headerHeight = siteHeader.offsetHeight;
        const offset = 80;

        const root = document.documentElement;

        root.style.setProperty('--header-height', headerHeight + offset + `px`);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    menu();
    logos();
    glightbox();
    slider();
    accordion();
    infiniteScroll();
    newsletter();
    loading();
    injectHeaderHeightVariable();
});